/* eslint-disable jsx-a11y/no-static-element-interactions */
import classnames from 'classnames';
import { isFunction } from 'lodash';
import React, { memo, useRef } from 'react';
import './SizeControl.scss';
function SizeControl({ className, onResize, onResizeStop }) {
    const classes = classnames('SizeControl', className);
    const startPoint = useRef(null);
    const onMouseMove = useRef((e) => {
        if (!startPoint.current)
            return;
        if (isFunction(onResize))
            onResize({
                x: e.clientX - startPoint.current.x,
                y: e.clientY - startPoint.current.y,
            });
    });
    const cancelEvents = useRef((e) => {
        document.removeEventListener('mouseup', cancelEvents.current);
        document.removeEventListener('mousemove', onMouseMove.current);
        if (isFunction(onResizeStop))
            onResizeStop(e);
        startPoint.current = null;
    });
    const addmouseup = useRef(() => {
        document.addEventListener('mouseup', cancelEvents.current);
        document.addEventListener('mousemove', onMouseMove.current);
    });
    const handleMouseDown = (e) => {
        document.addEventListener('mousemove', onMouseMove.current);
        startPoint.current = {
            x: e.clientX,
            y: e.clientY,
        };
        addmouseup.current();
    };
    const handleMouseUp = (e) => {
        startPoint.current = null;
        if (isFunction(onResizeStop))
            onResizeStop(e);
        cancelEvents.current(e);
    };
    return React.createElement("div", { className: classes, onMouseDown: handleMouseDown, onMouseUp: handleMouseUp });
}
export default memo(SizeControl);
